import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  const phoneNumber = "972508366932";
  const message = encodeURIComponent("שלום, אשמח לקבל פרטים נוספים על שירות השידוכים");
  
  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] rounded-full shadow-lg hover:scale-110 hover:shadow-xl transition-all duration-300 group"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-cream fill-cream" />
      <span className="absolute right-16 bg-navy text-cream px-3 py-2 rounded-lg text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap shadow-elegant">
        דברו איתנו בוואטסאפ
      </span>
    </a>
  );
};

export default WhatsAppButton;
